// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3164":"67abf2726a9c53e1","5015":"a51c32251b513f81","5261":"c730db16cc6ce76d","7127":"7bcedc1b09688c2a","9814":"f2a2e8b3aa150238"}[chunkId] + ".css";
};